import AnonymousRoute from './anonymous';
import AuthenticatedRoute from './authenticated';

export { AnonymousRoute, AuthenticatedRoute };



// WEBPACK FOOTER //
// ./src/components/routes/index.js